import * as XLSX from "xlsx";

// Shared CSV export for every admin table. `columns` is an array of
// { header, value } where value is either a field name or a (row) => cell
// accessor — mirroring the same body/format functions each table's
// <Column> definitions already use, so the CSV matches what's on screen.
export const exportTableToCsv = (filename, rows, columns) => {
    const data = (rows || []).map((row) => {
        const record = {};
        columns.forEach(({ header, value }) => {
            const cell = typeof value === "function" ? value(row) : row?.[value];
            record[header] = cell === undefined || cell === null ? "-" : cell;
        });
        return record;
    });

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Export");
    XLSX.writeFile(workbook, filename, { bookType: "csv" });
};
